<template>
<v-text-field
  :readonly="readonly"
  :value="computedValue"
  :rules="[floatRule]"
  v-bind="$attrs"
  v-on="$listeners"
  @input="setValue"
  @keydown="isNumber"
  @paste.prevent
>
  <template #append>
    <v-col 
      class="pa-0"
      v-if="!readonly"
    >
      <v-row
        no-gutters
        class="creament-arrow"
      >
        <v-icon
          size="12px"
          color="black"
          @click="increment"
        >
          mdi-chevron-up
        </v-icon>
      </v-row>
      <v-row
        no-gutters
        class="creament-arrow"
      >
        <v-icon
          size="12px"
          color="black"
          @click="decrement"
          :disabled="computedValue <= 0"
        >
          mdi-chevron-down
        </v-icon>
      </v-row>
    </v-col>
  </template>
</v-text-field>
</template>
<script>
export default {
  props: {
    readonly: {
      type: Boolean,
    },
    value: {
      required: true,
    }
  },
  computed: {
    computedValue: {
      get() {
        return Number(this.value);
      },
      set(nV) {
        this.setValue(Number(nV));
      }
    }
  },
  methods: {
    decrement() {
      if (this.readonly) {
        return;
      }
      const newValue = this.computedValue - 0.01;
      const fixedNewValue = newValue.toFixed(2);

      this.setValue(fixedNewValue);
    },
    increment() {
      if (this.readonly) {
        return;
      }
      const newValue = this.computedValue + 0.01;
      const fixedNewValue = newValue.toFixed(2);

      this.setValue(fixedNewValue);
    },
    setValue(value) {
      this.$emit('input', value);
    },
  },
  created() {
    this.floatRule = v =>
      /([0-9]+([.][0-9]+)?)/.test(v) || this.$i18n.t('default.mustBeNumber');
  }
}
</script>
<style lang="scss" scoped>
.creament-arrow {
  border: 1px solid #bababa; 
  border-radius: 5px;
  margin: 0 !important;
}
</style>